import { render, staticRenderFns } from "./NotificationTemplateDetail.vue?vue&type=template&id=63bfaa44&"
import script from "./NotificationTemplateDetail.vue?vue&type=script&lang=ts&"
export * from "./NotificationTemplateDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports